import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-line_genplan",
  "use": "icon-line_genplan-usage",
  "viewBox": "0 0 1 102",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1 102\" id=\"icon-line_genplan\"><path stroke=\"#989898\" stroke-dasharray=\"1 3\" stroke-linecap=\"round\" stroke-miterlimit=\"50\" d=\"M.5.5v103\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol